import Error from 'components/alerts/Error'
import Success from 'components/alerts/Success'
import React from 'react'
import { Input, InputGroup } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';

export default class ResendForm extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.state = {
            newEmail: '',
            error: false,
            success: false,
        }
        this.changeValue = this.changeValue.bind(this);
        this.resendEmail = this.resendEmail.bind(this);
    }

    public changeValue(e: any) {
        e.preventDefault();
        this.setState({ newEmail: e.target.value, error: false, success: false })
    }

    public resendEmail() {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.newEmail)) {
            this.setState({ error: true });
            return;
        }

        fetchGraphQL(
            `
            mutation {
                ticket {
                    resend(email:"${this.state.newEmail}",code:"${this.props.code}")
                }
            }
            `
        ).then(res => {
            if (res !== undefined && res.ticket !== undefined && res.ticket.resend !== null) {
                if (res.ticket.resend) {
                    this.setState({ success: true })
                } else {
                    this.setState({ error: true })
                }
            }
        });
    }
    public render() {
        return (
            <div>
                <InputGroup>
                    <Input
                        autoFocus={!this.state.loadFirst}
                        disabled={this.state.loading}
                        type="text"
                        name="search"
                        id="search"
                        placeholder="email address "
                        style={{ height: '27px', width: '250px', fontSize: '12px', backgroundColor: '#ebecf1', borderRadius: '10px' }}
                        value={this.state.searchTerm}
                        onChange={(e) => {
                            this.changeValue(e)
                        }}
                    /><div style={{ width: '6px' }} />
                    {
                        this.state.loading ? null :
                            <button
                                className='new-button-white-4'
                                onClick={this.resendEmail}
                                style={{
                                    border: 'none', cursor: 'pointer'
                                }}
                            >
                                RESEND
                        </button>
                    }
                </InputGroup>
                {
                    this.state.success ? <div><p><br /></p><Success content="Email resent successfully" /></div> : null
                }
                {
                    this.state.error ? <div><p><br /></p><Error content='Please enter a valid email' /></div> : null
                }
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/ResendForm.tsx